import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { initialPath } from '~misc/paths';
 import { db } from '~/db/db';

export default function useRegistrationJourney({ clienteId, tipo, enabled, rotaFinal }) {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();

  const [etapa, setEtapa] = useState(null);
  const limite = params.get('limite-credito');
  const mapeamento = params.get('mapeamento');
  const iniciar = params.get('jornada') === 'cadastro';
  const getNextStep = useCallback(async (clienteId) => {
    const id = Number(clienteId);
    const valoresBuscados = [id, String(id)];

    for (const table of [db.funilObraDashboard, db.funilObra]) {
      const mapeamento = await table
        .where('clienteId')
        .anyOf(valoresBuscados)
        .filter((item) => !item.deletadoEm)
        .first();

      if (mapeamento) {
        return 'simuladores';
      }
    }
    return 'mapeamento';
  }, []);

  const removeParams = useCallback((parametro) => {
    setParams((current) => {
      const next = new URLSearchParams(current);
      next.delete(parametro);
      return next;
    }, { replace: true });
  }, [setParams]);

  const proximaEtapa = useCallback(async () => {
    setEtapa(await getNextStep(clienteId));
    if (limite === 'pulado') removeParams('limite-credito');
    else if (iniciar) removeParams('jornada');
  }, [clienteId, limite, iniciar, removeParams, getNextStep]);

  useEffect(() => {
    if (!enabled || !clienteId) return;
    if (mapeamento === 'sucesso') {
      setEtapa('mapeamento-sucesso');
      removeParams('mapeamento');
      return;
    }
    if (limite === 'sucesso') {
      setEtapa('credito-sucesso');
      removeParams('limite-credito');
      return;
    }
    if (limite !== 'pulado' && !iniciar) return;
    let cancelled = false;

    getNextStep(clienteId).then((next) => {
      if (cancelled) return;
      setEtapa(next);

      if (limite === 'pulado') removeParams('limite-credito');
      else if (iniciar) removeParams('jornada');
    })
    return () => { cancelled = true; };
  }, [enabled, clienteId, limite, mapeamento, iniciar, removeParams, getNextStep]);

  const finalizar = () => {
    setEtapa(null);
    navigate(rotaFinal ?? `${initialPath}/carteira/solicitacoes`);
  };

  const mapear = () => {
    setEtapa(null);
    navigate(`${initialPath}/funil-de-obras/${clienteId}/mapeamento?origem=${tipo}&retorno=${tipo}`);
  };

  return { etapa, setEtapa, proximaEtapa, finalizar, mapear };
}
